import { Component, input, output } from '@angular/core';
import { QaiButtonComponent, QaiCallButtonComponent } from '@qai/ui';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  imports: [
    MatTooltipModule,
    QaiButtonComponent,
    QaiCallButtonComponent,
    TranslocoModule,
  ],
  selector: 'app-pathway-call-controls',
  standalone: true,
  styleUrls: ['./call-controls.css'],
  templateUrl: './call-controls.html',
})
export class PathwayCallControlsComponent {
  isMicOn = input.required<boolean>();
  isVideoOn = input.required<boolean>();
  isCameraAvailable = input.required<boolean>();
  showCameraButton = input.required<boolean>();
  showMicrophoneButton = input.required<boolean>();
  disableMicButton = input.required<boolean>();
  disableVideoButton = input.required<boolean>();
  disableConfirmActionButton = input.required<boolean>();
  confirmActionLabel = input.required<string>();

  microphoneClicked = output<void>();
  videoClicked = output<void>();
  onConfirmActionClicked = output<void>();

  protected handleMicrophoneClick() {
    this.microphoneClicked.emit();
  }

  protected handleVideoClick() {
    this.videoClicked.emit();
  }

  protected handleOnConfirmActionClick() {
    this.onConfirmActionClicked.emit();
  }
}
